var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.999,
    viewBox: "0 0 14 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "branch",
    d: "M14,2.333a2.333,2.333,0,1,0-2.917,2.259v.074a1.752,1.752,0,0,1-1.75,1.75H4.667A2.9,2.9,0,0,0,2.917,7V4.593a2.333,2.333,0,1,0-1.167,0V9.407a2.333,2.333,0,1,0,1.167,0V9.333a1.752,1.752,0,0,1,1.75-1.75H9.333A2.92,2.92,0,0,0,12.25,4.666V4.592A2.338,2.338,0,0,0,14,2.333Zm-12.833,0A1.167,1.167,0,1,1,2.333,3.5,1.168,1.168,0,0,1,1.167,2.333ZM3.5,11.667A1.167,1.167,0,1,1,2.333,10.5,1.168,1.168,0,0,1,3.5,11.667ZM11.667,3.5a1.167,1.167,0,1,1,1.167-1.167A1.168,1.168,0,0,1,11.667,3.5Z",
    fill: "#677b87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.74120c4187dffcea4286f3c3fb0c32b8.svg";
export { ForwardRef as ReactComponent };